// @flow
import React, { Component } from "react";
import { isEqual } from "lodash/fp";
import {
  search,
  tracks as horseRacing,
  bets,
  account,
  promo,
  eyeHide,
  more
} from "@fdr/static-ui/Icons/icons";
import type { Theme } from "@tvg/types/Theming";
import { isXSell } from "@tvg/sh-utils/mobileUtils";
import FooterLinkMolecule, {
  type Props as FooterLinkProps
} from "../../_molecules/FooterLink";
import FooterNav from "./styled-components";

const fdrIcons = {
  home: horseRacing,
  tracks: search,
  bets,
  account,
  modeBalanceHidden: eyeHide,
  promos: promo,
  more
};

export type NavigationLayoutType = "horizontal" | "vertical";

type Props = {
  /**
   * list of links
   */
  linksList: FooterLinkProps[],
  /**
   * active path
   */
  active: number,
  /**
   * changes the layout of the navigation to be vertical or horizontal
   */
  layout: NavigationLayoutType,
  /**
   * Theming support
   */
  theme: Theme,
  /**
   * User balance
   */
  balance: number,
  /**
   * Is the user logged in
   */
  isLogged: boolean,
  /**
   * Is the login required to access the Account Page
   */
  noLoginRequiredForAccountPage: boolean
};

export class Footer extends Component<Props> {
  static defaultProps = {
    linksList: [],
    active: 0,
    layout: "horizontal",
    theme: {
      themeName: "tvg"
    },
    balance: 0,
    isLogged: false,
    noLoginRequiredForAccountPage: false
  };

  shouldComponentUpdate(nextProps: Props) {
    return (
      nextProps.linksList.length !== this.props.linksList.length ||
      nextProps.active !== this.props.active ||
      !isEqual(nextProps, this.props)
    );
  }

  render() {
    const { isLogged } = this.props;

    return (
      !!this.props.linksList.length && (
        <FooterNav layout={this.props.layout}>
          {this.props.linksList.map((element, index) => {
            const elementKey = element.key.toLowerCase();

            let icon;

            if (elementKey === "account" && isLogged && !element.showBalance) {
              icon = eyeHide;
            } else if (
              elementKey === "account" &&
              this.props.noLoginRequiredForAccountPage &&
              !isXSell() &&
              !isLogged
            ) {
              icon = more;
            } else {
              icon = fdrIcons[elementKey];
            }

            return (
              <FooterLinkMolecule
                // eslint-disable-next-line react/no-array-index-key
                key={`footer-${index}-${element.label}`}
                qaLabel={`footer-${element.key}`}
                label={element.label}
                href={element.href}
                icon={icon}
                counter={element.counter}
                selected={this.props.active === index}
                onClick={element.onClick}
                showBalance={element.showBalance}
                balance={this.props.balance}
              />
            );
          })}
        </FooterNav>
      )
    );
  }
}

// $FlowFixMe
export default Footer;
